<template>
  <span class="">
    <el-button
      ref="btnPrint"
      class="btn"
      :class="options.addClass ? options.addClass : ''"
      :size="options.size ? options.size : 'small'"
      :type="options.btnType ? options.btnType : ''"
      :loading="keyBtn"
      @click="openMenu($event)"
      v-if="hasPower"
      :disabled="isDisabled"
      icon="iconfont icondayin"
    >
      <!-- <i class="iconfont icondayin" v-show="!options.isHideIcon?true:false"></i> -->
      {{ !options.hideTitle ? options.btnTitle : '' }}
    </el-button>

    <canvas id="myCanvas" width="200" height="100" style="border:1px solid #c3c3c3;"></canvas>
  </span>
</template>

<script>
import template from './template'
import { commonFun } from '@utils/common'
import { mapActions, mapGetters } from 'vuex'
import { getLodop, printImages } from '@/utils/LodopFuncs.js'
export default {
  name: 'Print',
  data() {
    return {
      versionMsg: '',
      keyBtn: false,
      hasLodop: false,
      selection: [],
      hasBeforePrint: true,
      language: '',
      lodop: null, // 打印插件对象
      prinyValue: undefined // 获取打印机的index
    }
  },
  props: {
    getPrintData: Function,
    beforePrint: Function,
    typeName: {
      type: String,
      default: () => {
        return 'oneAndtwoLinkPage'
      } // 是否有一联两联面单，默认有
    },
    options: {
      type: Object,
      default: () => {
        return {
          btnTitle: this.$lang('打印'),
          btnType: ''
        }
      }
    },
    hasPower: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['langList']),
    isChrome() {
      return navigator.userAgent.match(/Chrome\D?\d+/i)
    },
    isIos() {
      return navigator.userAgent.match(/macintosh|mac os x/i)
    },
    isChromeVer() {
      let verChrome = navigator.userAgent.match(/Chrome\D?\d+/i)
      verChrome = verChrome[0].match(/\d+/)
      if (verChrome[0] >= 41) {
        return true
      } else {
        return false
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    }
  },
  //
  mounted() {
    setTimeout(() => {
      this.checkIsInstall()
    }, 200)

    setTimeout(() => {
      this.lodop = getLodop()
    }, 500)
  },
  methods: {
    ...mapActions(['SET_USER', 'LOGIN_INIT', 'SET_SYSTEM_MENU']),
    toImage(terminalDispatchCode) {
      const codeArr = terminalDispatchCode.split(' ')
      const secondCode = codeArr[1]
      if (!secondCode) return ''
      const canvasDom = document.getElementById('myCanvas')
      const ctx = canvasDom.getContext('2d')
      ctx.clearRect(0, 0, canvasDom.width, canvasDom.height)
      ctx.globalAlpha = 0.4
      ctx.fillStyle = '#00000'
      ctx.font = '60px Arial'
      ctx.fillText(secondCode, 10, 50)
      const imgSrc = canvasDom.toDataURL('image/png')
      return imgSrc
    },
    checkIsInstall() {
      try {
        this.LODOP = this.$getLodop()
        this.hasLodop = !!this.LODOP.VERSION
      } catch (err) {
        console.log('print:' + err)
      }
    },
    async openMenu(e) {
      // alert(e)
      if (e) {
        this.event = e
      }
      if (this.beforePrint && this.hasBeforePrint) {
        this.beforePrint()
        return
      }
      this.hasBeforePrint = true
      if (this.isIos) {
        this.$message.warning(this.$lang('IOS系统暂不支持安装打印插件'))
        return
      }
      if (!this.isChrome) {
        const tip = '建议使用谷歌浏览器进行打印'
        this.dowmloadChrome(tip)
      } else if (this.isChrome && !this.isChromeVer) {
        const tip = '当前谷歌浏览器版本过低，请重新下载并安装'
        this.dowmloadChrome(tip)
      } else {
        if (!this.hasLodop) {
          // 判断是否已经下载过插件
          this.dowmloadZip()
        } else {
          this.selection = []
          if (this.checkPriny()) {
            // this.showLinks(e)
            this.chooseLanauage(e)
          }
        }
      }
    },

    checkPriny() {
      const targetPrinter = this.userInfo.targetPrinter
      if (!targetPrinter) {
        this.$message.error(this.$lang('请在右上角“我的资料”中进行打印设置默认打印机'))
        return false
      }
      const printCount = this.LODOP.GET_PRINTER_COUNT()
      const printList = []
      // 获取所有打印机的名称
      for (let i = 0; i < printCount; i++) {
        const name = this.LODOP.GET_PRINTER_NAME(i)
        printList.push(name)
      }
      if (!printList.includes(targetPrinter)) {
        this.$message.error(this.$lang('打印机硬件已变更，请在右上角 “我的资料” 中进行打印设置'))
        return false
      } else {
        this.prinyValue = printList.indexOf(targetPrinter)
        this.LODOP.SET_PRINTER_INDEXA(printList.indexOf(targetPrinter))
      }
      return true
    },

    // 下载谷歌浏览器
    dowmloadChrome(tip) {
      this.$confirm(this.$lang(tip), this.$lang('温馨提示'), {
        confirmButtonText: this.$lang('去下载'),
        cancelButtonText: this.$lang('取消'),
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          const link = document.createElement('a')
          link.target = '_blank'
          link.href = 'https://www.google.cn/chrome/'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
        })
        .catch(_ => {})
    },
    // 下载插件
    dowmloadZip() {
      this.$alert(
        `<p class="downloadZip-p">${this.$lang('请先下载并安装CLodop打印插件，才可进行打印，下载成功后请刷新本页面，并启动CLodop插件。')}</p>
        <a class="downloadZip-a" href="https://vipgw.jtcargo.co.id/print/CLodop-Setup-for-Win32/Lodop6.226Clodop4.142.zip" target="_self">${this.$lang(
          'CLodop_Setup_for_Win32NT.exe'
        )}</a>
        <a class="downloadZip-a" href="https://vipgw.jtcargo.co.id/print/CLodop-Setup-for-Win64/CLodop_Setup_for_Win64NT_4.142EN.zip" target="_self">${this.$lang(
          'CLodop_Setup_for_Win64NT_4.142EN.exe'
        )}</a>`,
        this.$lang('温馨提示'),
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
        }
      )
    },
    chooseLanauage(e) {
      // let left, top
      // if (e) {
      //   left = this.$refs.btnPrint.$el.getBoundingClientRect().left + this.$refs.btnPrint.$el.getBoundingClientRect().width / 2
      //   top = this.$refs.btnPrint.$el.getBoundingClientRect().top + this.$refs.btnPrint.$el.getBoundingClientRect().height / 2
      // }
      // // console.log('this.langList', this.langList)
      // const langListFilter = JSON.parse(JSON.stringify(this.langList)
      //   .replace(/label/g, 'val')).map(({ val, value }) => ({ val, value }))
      // // console.log('this.langList1', langListFilter)

      // let langListValue
      // langListFilter.forEach(item => {
      //   item.abled = true
      //   item.val = this.$lang(item.val)
      //   if (item.value === 'ID') {
      //     langListValue = [item]
      //   }
      // })
      this.language = 'ID'
      this.showLinks(e)
      // console.log('langListFilter', langListFilter)
      // alert(langListFilter)
      // const menuListLanauage = langListValue
      // this.$rightMenu.open({
      //   target: e,
      //   menuList: menuListLanauage,
      //   posobj: {
      //     left: e.clientX || left,
      //     top: e.clientY || top,
      //   },
      //   callback: ({ value }) => {
      //     this.language = value
      //     this.showLinks(e)
      //   },
      // })
    },
    // 一联两联打印
    showLinks(e) {
      const menuList = [
        {
          val: this.$lang('两联面单'),
          abled: true,
          value: 'twoLinkPage'
        },
        {
          val: this.$lang('一联面单'),
          abled: true,
          value: 'oneLinkPage'
        }
      ]
      const surfaceFormat = this.userInfo.surfaceFormat
      if (surfaceFormat === 2) {
        this.toPrint(menuList[1].value)
      } else if (surfaceFormat === 3) {
        this.toPrint(menuList[0].value)
      } else {
        // let left, top
        // if (e) {
        //   left = this.$refs.btnPrint.$el.getBoundingClientRect().left + this.$refs.btnPrint.$el.getBoundingClientRect().width / 2
        //   top = this.$refs.btnPrint.$el.getBoundingClientRect().top + this.$refs.btnPrint.$el.getBoundingClientRect().height / 2
        // }
        this.toPrint('oneLinkPage')
        // this.$rightMenu.open({
        //   target: e,
        //   menuList: menuList,
        //   posobj: {
        //     left: e.clientX || left,
        //     top: e.clientY || top,
        //   },
        //   callback: ({ value }) => {
        //   },
        // })
      }
    },

    // 选择面单后去打印
    async toPrint(value) {
      this.keyBtn = true
      this.$rightMenu.close()
      try {
        const type = 1 // 只有一联面单模板，暂时这里写死
        this.selection = await this.getPrintData(type, this.language)
        if (this.selection) {
          const params = {
            images: [this.selection],
            type: 'stream',
            printerValue: this.prinyValue
          }
          printImages(params, () => {
            this.keyBtn = false
          })
        }
      } catch (err) {
        this.keyBtn = false
      }
    },
    // 一联二联
    linkPrint(printType) {
      const dayObj = commonFun.getCurDate()
      const result = []
      const limit = 20
      for (let j = 0; j < this.selection.length; j += limit) {
        result.push(this.selection.slice(j, j + limit))
      }
      if (printType === 'twoLinkPage') {
        result.forEach((item, index) => {
          setTimeout(() => {
            const groupIdx = limit * index
            this.createTwoLinkPages(item, groupIdx, this.LODOP, printType, dayObj)
          }, 0)
        })
      } else if (printType === 'oneLinkPage') {
        result.forEach((item, index) => {
          const groupIdx = limit * index
          setTimeout(() => {
            this.createOneLinkPages(item, groupIdx, this.LODOP, printType, dayObj)
          }, 0)
        })
      }
      this.keyBtn = false
      // this.LODOP.PREVIEW()
    },
    // 一联面单获取
    createOneLinkPages(arr, groupIdx, LODOP, printType, dayObj) {
      arr.forEach((item, index) => {
        item.dataUrl = item.terminalDispatchCode ? this.toImage(item.terminalDispatchCode) : ''
        item.codMoneyTag = item.codNeed === 1 && item.codMoney ? '****' : ''
        this.subStringStr(item)
        const htmlUrl = template[printType](item, groupIdx + index + 1, this.selection.length, dayObj, this.$lang)
        LODOP.SET_PRINT_PAGESIZE(1, '76mm', '130mm')
        LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', htmlUrl) // 打印html
        LODOP.SET_PRINT_STYLE('AlignJustify', 2) // 字空隙
        // LODOP.ADD_PRINT_BARCODE(140, 232, 46, 170, '128Auto', item.waybillNo)
        LODOP.ADD_PRINT_BARCODE(135, 232, 46, 240, '128Auto', item.waybillNo)
        LODOP.SET_PRINT_STYLEA(0, 'Angle', -90)
        LODOP.ADD_PRINT_TEXT(41, 177, 200, 10, this.$lang('服务热线:400 820 1666'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 7)

        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(188, 47, 180, 10, item.receiverCompany)
        LODOP.SET_PRINT_STYLEA(0, 'TextNeatRow', true)
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 7)

        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(252, 44, 180, 10, item.senderCompany)
        LODOP.SET_PRINT_STYLEA(0, 'TextNeatRow', true)
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 7)

        LODOP.ADD_PRINT_BARCODE(305, 33, 170, 55, '128Auto', item.waybillNo)
        // LODOP.ADD_PRINT_BARCODE(305, 33, 250, 55, '128Auto', item.waybillNo)
        LODOP.ADD_PRINT_BARCODE(450, 10, 76, 76, 'QRCode', 'http://weixin.qq.com/r/fCk7I1fE7AqTrRNA93xu')
        LODOP.ADD_PRINT_TEXT(452, 60, 200, 10, this.$lang('签收人/时间'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 8)
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(467, 60, 320, 10, this.$lang('您的签名代表您已签收此包裹，并确认商品信息无误'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 6)
        LODOP.SET_PRINT_STYLEA(0, 'Color', '#666')
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(477, 60, 300, 10, this.$lang('包装完好，没有划痕，破损等表面质量问题'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 6)
        LODOP.SET_PRINT_STYLEA(0, 'Color', '#666')
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        item.isBusiness === 1 && LODOP.ADD_PRINT_IMAGE(60, 230, 42, 24, `<img width="42" src=${require('@/assets/images/businessParcelLink.png')} />`)
        LODOP.NewPage()
      })
      LODOP.SET_PRINT_MODE('CUSTOM_TASK_NAME', '一联面单打印任务' + (groupIdx + 1)) // 为每个打印单独设置任务名
      process.env.NODE_ENV === 'development' ? this.LODOP.PREVIEW() : this.LODOP.PRINT()
      return
    },
    subStringStr(item) {
      item.receiverMobilePhone = item.receiverMobilePhon && item.receiverMobilePhone.length > 15 ? item.receiverMobilePhone.substring(0, 13) : item.receiverMobilePhone
      item.receiverTelphone = item.receiverTelphone && item.receiverTelphone.length > 15 ? item.receiverTelphone.substring(0, 13) : item.receiverTelphone
      item.senderMobilePhone = item.senderMobilePhone && item.senderMobilePhone.length > 15 ? item.senderMobilePhone.substring(0, 13) : item.senderMobilePhone
      item.senderTelphone = item.senderTelphone && item.senderTelphone.length > 15 ? item.senderTelphone.substring(0, 13) : item.senderTelphone
    },
    // 二联面单获取
    createTwoLinkPages(arr, arrIndex, LODOP, printType, dayObj) {
      arr.forEach((item, index) => {
        item.dataUrl = item.terminalDispatchCode ? this.toImage(item.terminalDispatchCode) : ''
        console.log(111, item.dataUrl)
        item.codMoneyTag = item.codNeed === 1 && item.codMoney ? '****' : ''
        this.subStringStr(item)
        const htmlUrl = template[printType](item, index + 1, this.selection.length, dayObj, this.$lang)
        LODOP.SET_PRINT_PAGESIZE(1, '100mm', '180mm')
        LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', htmlUrl) // 打印html
        LODOP.SET_PRINT_STYLE('AlignJustify', 2) // 字空隙
        LODOP.SET_PRINT_STYLE('FontName', '黑体')
        LODOP.ADD_PRINT_BARCODE(298, 45, 315, 55, '128Auto', item.waybillNo)
        LODOP.ADD_PRINT_TEXT(45, 268, 200, 10, this.$lang('服务热线:400 820 1666'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 7)
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(370, 10, 200, 10, this.$lang('签收人/时间'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 7)
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(390, 10, 320, 10, this.$lang('您的签名代表您已签收此包裹，并确认商品信息无误'))
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 6)
        LODOP.SET_PRINT_STYLEA(0, 'Color', '#666')
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        LODOP.ADD_PRINT_TEXT(402, 10, 300, 10, this.$lang('包装完好，没有划痕，破损等表面质量问题'))
        LODOP.SET_PRINT_STYLEA(0, 'Color', '#666')
        LODOP.SET_PRINT_STYLEA(0, 'FontSize', 6)
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 0)
        // LODOP.ADD_PRINT_BARCODE(358, 300, 70, 70, 'QRCode', 'http://weixin.qq.com/r/fCk7I1fE7AqTrRNA93xu');
        LODOP.ADD_PRINT_BARCODE(428, 206, 170, 42, '128Auto', item.waybillNo)
        item.isBusiness === 1 && LODOP.ADD_PRINT_IMAGE(65, 310, 52, 29, `<img src=${require('@/assets/images/businessParcelLink.png')} />`)
        LODOP.NewPage()
      })
      LODOP.SET_PRINT_MODE('CUSTOM_TASK_NAME', '二联面单打印任务' + (arrIndex + 1)) // 为每个打印单独设置任务名
      // this.LODOP.PRINT()
      process.env.NODE_ENV === 'development' ? this.LODOP.PREVIEW() : this.LODOP.PRINT()
    }
  }
}
</script>
<style lang="scss">
#myCanvas {
  position: absolute;
  right: 9999px;
}
.downloadZip-p {
  margin-bottom: 20px !important;
}
.downloadZip-a {
  text-decoration: none;
}
</style>
